// src/api/azureApi.js
import { createApiInstance } from './index';
import { getProjectContext, withProjectContext } from './projectContext';

const azureApi = createApiInstance();

/**
 * Azure Resource Graph API
 * 會自動注入 project_uuid
 */
export const azureResourceGraph = async (payload = {}) => {
  try {
    const { project_uuid } = getProjectContext();
    if (!project_uuid) {
      throw new Error('找不到有效的 project_uuid，請先選擇專案');
    }

    const finalPayload = withProjectContext(payload);

    const response = await azureApi.post('azure-resource-graph/', finalPayload);

    return response.data;
  } catch (error) {
    console.error('[AzureResourceGraph API Error]', error);
    throw error;
  }
};

export const postAzureResourceGraph = azureResourceGraph;
